<template>
  <div class="home">
    <UserRow msg="Welcome to ROA User App !!"/>
   
  </div>
</template>

<script>
// @ is an alias to /src
import UserRow from './dashboard/userRow'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  data(){
    return {
      list:{}
    }
  },
  components: {
    UserRow,
    // upload
  },
  computed:{
    ...mapGetters('user', {
      userList: 'list',
    })
  },
  methods:{
    CheckData(){
      this.$store.dispatch('user/fetchUsers')
    }
  },
  created(){
     
    //  this.$store.dispatch('user/fetchUsers').then(res=>{console.log(res)})
  }
}
</script>
<style  scoped>
@import './../../assets/css/common_chat.css';
</style>
